// src/features/auth/store/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, User } from '../types/authTypes';

const initialState: AuthState = {
  user: null,
  token: null,
  refreshToken: null,
  isAuthenticated: false,
  isLoading: false,
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = {
        id: action.payload.user_id,
        email: action.payload.email,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        profileImageUrl: action.payload.profile_image_url,
        permissions: JSON.parse(atob(action.payload.permissions)),
        userType: action.payload.user_type
      };
      // Update tokens from login response
      state.token = action.payload.access;
      state.refreshToken = action.payload.refresh;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.token = null;
      state.refreshToken = null;
    },
    updateTokens: (state, action) => {
      // Update tokens from refresh response
      state.token = action.payload.access;
      state.refreshToken = action.payload.refresh;
      state.isAuthenticated = true;
    },
    // Enhanced logout to clear all auth state
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
    },
    updateUserProfile: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      } else {
        state.user = action.payload as User;
      }
    },
    
    
  }
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  updateTokens,
  logout,
  updateUserProfile
} = authSlice.actions;

export default authSlice.reducer;